@if (selectedDateRangeName() === undefined) {
  <div class="no-date-range">
    <p>No date range selected.</p>
  </div>
} @else if (loading) {
  <div class="loading">
    Loading activity data...
  </div>
} @else if (activity.length === 0) {
  <div class="no-data">
    <p>No activity data available.</p>
  </div>
} @else {
  <div class="mb-2">
    <div class="w-100">
    <ngx-charts-line-chart
      [results]="activity"
      [scheme]="scheme"
      [xAxis]="true"
      [yAxis]="true"
      [xAxisTicks]="xAxisTicks"
      [xAxisTickFormatting]="xAxisTickFormatting"
      [rotateXAxisTicks]="true"
      xAxisLabel="Time"
      yAxisLabel="Activity">
    </ngx-charts-line-chart>
      </div>

    @if (selectedContext() !== undefined) {
      <div class="legend">
        <div class="legend-entry"><div class="legend-primary-activity"></div>{{ primaryActivity() }}</div>
        <div class="legend-entry"><div class="legend-secondary-activity"></div>{{ secondaryActivity() }}</div>
      </div>
    }
  </div>
}
<div class="mb-2">
  <div class="dropdown">
      <button [disabled]="loading"
              class="btn btn-info btn-info-shadow dropdown-toggle w-100"
              data-bs-toggle="collapse"
              data-bs-target="#animalActivityDateRangeDropDown"
              type="button">
          {{ selectedDateRangeName() || "Select date range" }}
      </button>
      <div aria-labelledby="animalActivityDateRangeDropDown" class="collapse w-100" id="animalActivityDateRangeDropDown">
        @for (dateRange of selectableDateRanges(); track dateRange) {
          <div (click)="selectDateRange(dateRange)"
             class="btn card m-1"
             data-bs-target="#animalActivityDateRangeDropDown"
             data-bs-toggle="collapse">{{ dateRange }}
        </div>
        }
      </div>
  </div>
</div>
<div class="mb-2">
  <div class="dropdown">
      <button [disabled]="loading"
              class="btn btn-info btn-info-shadow dropdown-toggle w-100"
              data-bs-toggle="collapse"
              data-bs-target="#contextDropDown"
              type="button">
          {{ selectedContext() || "Select context" }}
      </button>
      <div aria-labelledby="contextDropDown" class="collapse w-100" id="contextDropDown">
        @for (context of selectableContexts(); track context) {
          <div (click)="selectContext(context)"
             class="btn card m-1"
             data-bs-target="#contextDropDown"
             data-bs-toggle="collapse">{{ context }}
        </div>
        }
      </div>
  </div>
</div>
